<template>
<div class="row">
             <div class="col-md-4">
                <div class="form-group">
                   <label><small><b>Date</b></small></label>
                   <input type="date" name="Date" class="form-control">
                </div>
             </div>
             <div class="col-md-4">
                <div class="form-group mt-2 pt-4">
                   <label><small><b><input type="radio" name="Call" value="CallMissed" required  v-on:click="CallStatus = this.value" v-model="CallStatus">Call Missed</b></small></label>
                   <label><small><b><input type="radio" name="Call" v-on:click="CallStatus = this.value" value="CallEstablished" required v-model="CallStatus">Call Established</b></small></label>                  
                  </div>
               </div>
            <div class="col-md-4"></div>
             <div class="col-md-4">
                <div class="form-group">
                   <label><small><b>Adherent</b></small></label>
                   <select class="form-control" name="Adherent" :readonly="CallStatus != 'CallEstablished'">
                     <option value="">-</option> 
                     <option value="1">Yes</option>
                      <option value="0">No</option>
                   </select>
                </div>
             </div>
             <div class="col-md-4">
                <div class="form-group">
                   <label><small><b>Recovery</b></small></label>
                   <select class="form-control" name="Recovery" v-model="Recovery" :readonly="CallStatus != 'CallEstablished'">
                     <option value="">-</option>
                     <option value="True">Yes</option>
                     <option value="False">No</option>
                     <option value="Other">Other</option>
                   </select>
                </div>
             </div>
             <div class="col-md-4">
               <div class="form-group">
                  <label><small><b>If Others, Specify</b></small></label>
                  <input type="text" name="Others" class="form-control" v-model="RecoveryOthers" :readonly="Recovery != 'Other'">
               </div>
             </div>
             <div class="col-md-4">
               <div class="form-group">
                  <label><small><b>Work</b></small></label>
                  <select class="form-control" name="Work_" :readonly="CallStatus != 'CallEstablished'">
                     <option value="">-</option>
                     <option value="1">Yes</option>
                     <option value="0">No</option>
                  </select>
               </div>
            </div>
            <div class="col-md-4">
               <div class="form-group">
                  <label><small><b>Family Relation</b></small></label>
                  <select class="form-control" name="FamilyRelation" :readonly="CallStatus != 'CallEstablished'">
                     <option value="">-</option>
                     <option value="Positive">Positive</option>
	                  <option value="Negative">Negative</option>
                  </select>
               </div>
            </div>
            <div class="col-md-4">
               <div class="form-group">
                  <label><small><b>With Whom</b></small></label>
                  <select class="form-control" name="WithWhom" :readonly="CallStatus != 'CallEstablished'">
                     <option selected="selected" value="">-</option>
	                  <option value="Aunty">Aunty</option>
	                  <option value="Brother">Brother</option>
	                  <option value="Brother-in-Law">Brother-in-Law</option>
	                  <option value="Cousine">Cousine</option>
	                  <option value="Daughter">Daughter</option>
	                  <option value="Father">Father</option>
	                  <option value="Friend">Friend</option>
	                  <option value="Husband">Husband</option>
	                  <option value="Mother">Mother</option>
	                  <option value="Neighbor">Neighbor</option>
	                  <option value="Nephew">Nephew</option>
	                  <option value="Niece">Niece</option>
	                  <option value="Self">Self</option>
	                  <option value="Sister">Sister</option>
	                  <option value="Sister-in-Law">Sister-in-Law</option>
	                  <option value="SocialMobilizer">SocialMobilizer</option>
	                  <option value="Son">Son</option>
	                  <option value="Son-in-Law">Son-in-Law</option>
	                  <option value="Uncle">Uncle</option>
	                  <option value="Wife">Wife</option>
	                  <option value="Other">Other</option>
                  </select>
               </div>
            </div>
             <div class="col-md-4">
                <div class="form-group">
                   <label><small><b>Issues</b></small></label>
                   <select class="form-control" name="Issues" v-model="Issues" :readonly="CallStatus != 'CallEstablished'">
                     <option selected="selected" value="">-</option>
                     <option value="Request for detox">Request for detox</option>
                     <option value="Stock out in ART centers">Stock out in ART centers</option>
                     <option value="Shifted to other city/country">Shifted to other city/country</option>
                     <option value="Request for job">Request for job</option>
                     <option value="Missing from home">Missing from home</option>
                     <option value="Mismanagement of time">Mismanagement of time</option>
                     <option value="Poor health condition">Poor health condition</option>
                     <option value="Request for financial help">Request for financial help</option>
                     <option value="Complaint by family against negative attitude of client">Complaint by family against negative attitude of client</option>
                     <option value="General health issues">General health issues</option>
                     <option value="Poor health condition">Poor health condition</option>
                     <option value="Medical complications related to HIV Aids">Medical complications related to HIV Aids</option>
                     <option value="In jail">In jail</option>
                     <option value="Request for viral load">Request for viral load</option>
                     <option value="Other">Other</option>
                   </select>
                </div>
             </div>
             <div class="col-md-4">
               <div class="form-group">
                  <label><small><b>If Others, Specify</b></small></label>
                  <input type="text" name="IssueOther" class="form-control" v-model="IssueOthers" :readonly="Issues != 'Other'">
               </div>
             </div>
             <div class="col-md-4"></div>
             <div class="col-md-4">
                <div class="form-group">
                   <label>Followup</label>
                   <input type="checkbox" class="" name="FollowUp">
                </div>
             </div>
             <div class="col-md-4">
               <div class="form-group">
                  <label>Expired</label>
                  <input type="checkbox" class="" name="Expired">
               </div>
            </div>
            <div class="col-md-4">
               <div class="form-group">
                  <label>Missing</label>
                  <input type="checkbox" class="" name="Missing">
               </div>
            </div>
          </div>
</template>
<script>
export default{
    name: 'intouch',
    data(){
        return {
            // Intouch
            Recovery: true,
            Issues: "",
            CallEstablished: false,
            CallStatus: "CallEstablished"
        }
    },
    methods:{

    }
}
</script>